import React from "react";
import nav from "../../data/nav.json";
import social from "../../data/social.json";
import { Link as RouterLink } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareFacebook } from "@fortawesome/free-brands-svg-icons";
import { faSquareInstagram } from "@fortawesome/free-brands-svg-icons";
import { faSquareXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faSquareBehance } from "@fortawesome/free-brands-svg-icons";
import { faSquarePinterest } from "@fortawesome/free-brands-svg-icons";
import { faSquareEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faCoffee } from "@fortawesome/free-solid-svg-icons";


function SubFooter() {
  return (
    <footer className="footer-container">
      <div className="footer-link-container">
        <div className="footerLogo">
          <a href="/" className="linkHome">
            <img src="./img/cropped-logo-rage.png" alt="Bekky Rage" />
          </a>
        </div>
        <div className="footer-items">
          <ul>
            {nav?.map((item, index) =>
              <li key={index}>
                {item.type === "route" ? (
                  <RouterLink to={item.target} className="text-md">
                    {item.label}
                  </RouterLink>
                ) : (
                  <RouterLink to={`/#${item.target}`} className="text-md">
                    {item.label}
                  </RouterLink>
                )}
              </li>
            )}
          </ul>
        </div>
        <div className="footer-social-icon">
          <ul>
            {social?.map((item, index) =>
              <li key={index}>
                <a
                  href={item.href}
                  className="navbar-content"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={['fab', item.icon]} />
                </a>
              </li>
            )}
            <li>
              <a
                href="mailto:bekkyrage@gmail.com"
                className="navbar-content"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faSquareEnvelope} />
              </a>
            </li>
          </ul>
        </div>
      </div>


      <hr className="divider" />
      <div className="footer-content-container">
        <p className="footer-content">
          Copyright © {(new Date().getFullYear())} Bekky Rage
        </p>
        <p className="footer-content">
          <FontAwesomeIcon icon={faCoffee} /> Powered by Caffeine Drinks.
        </p>
      </div>
    </footer>
  );
}

export default SubFooter;
